<template >
	<div id="app">    	
		<div>
			<cabecalho />
			<breadcrumb />
		</div>
		<div>
			<div class="areaRenderizaPaginas">
				<router-view ref="corpoGeralPaginas" /> <!-- Os componentes serão renderizados aqui-->
			</div>
		</div>
        <div class="backgroundLogin">

        </div>
		
	</div>
</template>

<script>
import {praca} from './config.js';

let aux = praca;
import (`./css/${aux}/custom.css`);
import './css/principal.css';
import cabecalho from './components/sistema/Cabecalho'
import breadcrumb from './components/sistema/Breadcrumb'



export default {
	mixins: [ ],
	components: {cabecalho, breadcrumb},

	computed: {
		loggedIn() {			
			return this.$store.state.authenticationStore.status.loggedIn;
		}
    },

	methods:{
	
		/**
		 * Asynchronously load view (Webpack Lazy loading compatible)
		 * ESSENCIAL PARA CARREGAR OS COMPONENTES PARA LAZY LOADING - NÃO MEXER
		 */
		lazyLoadingAssincrono(name) { //Lazy Loading - subsitui o Import
			return function(resolve) { //o require da raiz ./ funciona
				require([name+'.vue'], m => resolve(m.default))
			}
		},

	},
	created(){
		
	},
	
}
</script>
